import React from "react";
import { Typography, Button } from "@mui/material";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import * as S from "./Styled"; 
import { useNavigate } from "react-router-dom";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";

const ErrorPage = ({ category }) => {
    const navigate = useNavigate();

    return (
        <>
            <NavBar /> 
            <S.ContainerErrorPage style={{ textAlign: "center", padding: "40px" }}>
                <ErrorOutlineIcon sx={{ fontSize: 80, color: '#1976d2', mb: 2 }} />
                <Typography variant="h2">
                404
                </Typography>
                <Typography variant="h5" gutterBottom>
                    Página não encontrada
                </Typography>

                <Typography variant="body1" gutterBottom>
                    Ops! Esta categoria não existe.
                </Typography>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => window.open("https://www.meucupom.com/", "_blank")}
                    sx={{ mt: 2 }}
                >
                    Ir para meu Cupom
                </Button>
            </S.ContainerErrorPage>
            <Footer/>
        </>
    );
};

export default ErrorPage;